
import LayoutSimple from "@/layouts/LayoutSimple.vue";
import { LocalHostToPartnerMapper } from "@/lib/utility/local-host-to-partner-mapper";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";
import ErrorCard from "../../components/utility/ErrorCard.vue";
import { PartnerActiveOfferModule } from "@/store/modules/partner-active-config.store";

@Component({
  components: {
    LayoutSimple,
    ErrorCard
  }
})
export default class ThgErrorPage extends Vue {
  items = [
    {
      text: "Website",
      disabled: false,
      href: "https://www.wirkaufendeinethg.de"
    },
    {
      text: "FAQ",
      disabled: false,
      href: "https://www.wirkaufendeinethg.de/faq/"
    },
    {
      text: "Impressum",
      disabled: false,
      href: "https://www.wirkaufendeinethg.de/impressum/"
    }
  ];

  loading = false;

  async reload() {
    try {
      this.loading = true;
      await LocalHostToPartnerMapper.tryGetPartnerByHost(window.location.hostname, {
        localhost: "devappwirkaufendeinethg"
      });
      await PartnerActiveOfferModule.loadDocuments(ReportModule.partner.id);

      this.$log.info("ReportModule.partner", ReportModule.partner);
      this.$log.info("PartnerActiveOfferModule.prices", PartnerActiveOfferModule.prices);
      this.$router.push({ path: "/" + ReportScreenEnum.thghome });
    } catch (error) {
      this.$log.error(error);
      this.$toast("Fehler beim Laden der Anwendung.");
      this.$router.push({ name: "PartnerContactError" });
    } finally {
      this.loading = false;
      ReportModule.setLoading(false);
    }
  }
}
